module.exports = __webpack_public_path__ + "0b282eca378a22efe4a893424fbf15d5.svg";